/**
 * File blog-social-share.js.
 * Handles scripts needed for blog post social share buttons.
 */

const btns = document.querySelectorAll(".blog-social-btns__btn");
const copier = document.querySelector(".blog-social-btns__copier");
const copy = document.querySelector(".blog-social-btns__copy");
const block = document.querySelector(".blog-social-btns");
const postTitle = block.getAttribute("data-title");
const postPermalink = block.getAttribute("data-permalink");
const features = "menubar=yes,location=yes,resizable=yes,scrollbars=yes,width=500,height=500";

function copyLink() {
  copy.select();
  document.execCommand("copy");
}

function openWindow(url, name) {
  window.open(url, name, features);
}

function trackSocialClick(name) {
  let properties = {
    post: postTitle,
    url: postPermalink,
    button_type: name
  };

  segment(
    'track',
    'Social Button Clicked',
    properties
  );
}

// Inits
for (var i = 0; i < btns.length; i++) {
  const thisBtn = btns[i];
  const name = thisBtn.getAttribute("data-name");
  const url = thisBtn.getAttribute("data-url");
  const isLink = thisBtn.classList.contains("blog-social-btns__copier");
  if (isLink) {
    thisBtn.addEventListener("click", function(e) {
      trackSocialClick(name);
      copyLink();
    });
  } else {
    thisBtn.addEventListener("click", function(e) {
      trackSocialClick(name);
      openWindow(url, name);
    });
  }
}

